import { https } from "../http";
import store from "../store";
import {
  setLoading,
  setDashboardCounts,
  setDashboardNotes,
  setStaffDashboardCounts,
  setStaffLoadingCount,
  setDashboardMAR,
  setDashboardPendingNotes,
  setDashboardTasks,
  setDashboardMARLoading,
  setDashboardPendingNotesLoading,
  setDashboardPendingActions,
  setDashboardPendingActionsLoading,
} from "../store/reducers/dashboard";
import { showError } from "../utils/index";

// GET
const getDashboardCounts = async (showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(`/me/dashboard`);
    if (response?.status === 200) {
      store.dispatch(setDashboardCounts(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// POST /me/staff-dashboard
const getStaffDashboardCounts = async (date, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setStaffLoadingCount(true));
    let response = await https().post(`/me/staff-dashboard`, date);
    if (response?.status === 200) {
      store.dispatch(setStaffDashboardCounts(response?.data));
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  } finally {
    store.dispatch(setStaffLoadingCount(false));
  }
};

const getPendingNotes = async (page, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setDashboardPendingNotesLoading(true));
    let response = await https().get(`/note/dashboard/pandingNotes`);
    if (response?.status === 200) {
      store.dispatch(setDashboardPendingNotes(response?.data?.data));
      store.dispatch(setDashboardPendingNotesLoading(false));
    }
  } catch (error) {
    store.dispatch(setDashboardPendingNotesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const getTodaysNotes = async (data, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(
      `/note?page=all&date=today&search=${data}`
    );

    if (response?.status === 200) {
      store.dispatch(setDashboardNotes(response?.data?.notes));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getTodaysTasks = async (data, startDate, endDate, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(
      `/task/get-tasks?page=1&perPage=10&status=all&date=today&search=${data}&startDate=${startDate}&endDate=${endDate}`
    );
    if (response?.status === 200) {
      store.dispatch(setDashboardTasks(response?.data?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getTodaysMAR = async (
  page = localStorage.getItem("calendar_date"),
  showLoading = true,
) => {
  try {
    store.dispatch(
      setDashboardMAR({
        newMar: [],
        count: 0,
      })
    );
    if (showLoading) store.dispatch(setDashboardMARLoading(true));
    let response = await https().get(
      `/mar/get?client=undefined&page=${page}&filterDateStart=undefined&filterDateEnd=undefined&filterType=all&logSearch=undefined`
    );
    if (response?.status === 200) {
      let save = response?.data?.data;
      store.dispatch(setDashboardMAR(save));
      store.dispatch(setDashboardMARLoading(false));
    }
  } catch (error) {
    store.dispatch(setDashboardMARLoading(false));
    showError(
      error?.response?.data?.message || "An error occurred",
      error?.response?.status || 500
    );
  }
};

const getPendingActions = async (page = 1, limit = 20) => {
  try {
    store.dispatch(setDashboardPendingActionsLoading(true));

    const response = await https().get(`/note/dashboard/pending-actions?page=${page}&limit=${limit}`);

    if (response?.status === 200) {
      store.dispatch(setDashboardPendingActions(response.data));
      store.dispatch(setDashboardPendingActionsLoading(false));
      return response.data;
    }
  } catch (error) {
    store.dispatch(setDashboardPendingActionsLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export {
  getDashboardCounts,
  getTodaysNotes,
  getStaffDashboardCounts,
  getTodaysMAR,
  getPendingNotes,
  getTodaysTasks,
  getPendingActions
};
